"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CircleButton = require("./CircleButton.styles");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CircleButton = function CircleButton(_ref) {
  var padding = _ref.padding,
      size = _ref.size,
      backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      src = _ref.src,
      onClick = _ref.onClick,
      color = _ref.color,
      style = _ref.style,
      icon = _ref.icon,
      type = _ref.type;
  var clonedIcon = (0, _react.useMemo)(function () {
    if (icon) {
      return (0, _react.cloneElement)(icon, {
        style: {
          width: '100%',
          height: '100%'
        }
      });
    }
  }, [icon]);
  return (0, _core.jsx)(_CircleButton.MiniButton, {
    size: size,
    padding: padding,
    borderColor: borderColor,
    borderWidth: borderWidth,
    backgroundColor: backgroundColor,
    onClick: onClick,
    color: color,
    style: style,
    type: type
  }, icon && clonedIcon, !icon && src && (0, _core.jsx)(_CircleButton.MiniButtonImage, {
    src: src
  }));
};

CircleButton.defaultProps = {
  padding: '2px',
  size: '30px',
  backgroundColor: undefined,
  borderColor: undefined,
  borderWidth: '0px',
  color: undefined,
  style: undefined,
  src: undefined,
  icon: null,
  onClick: undefined,
  type: 'button'
};
CircleButton.propTypes = {
  padding: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array]),
  backgroundColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  borderWidth: _propTypes["default"].string,
  src: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  icon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  onClick: _propTypes["default"].func,
  color: _propTypes["default"].string,
  style: _propTypes["default"].object,
  type: _propTypes["default"].string
};
var _default = CircleButton;
exports["default"] = _default;

//# sourceMappingURL=CircleButton.js.map